module.exports = __webpack_public_path__ + "static/media/delete.6a4cc37f.svg";